import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  IMagacinDto,
  MailReceiverDto,
  PrebacivanjeUslugeURobuCommand,
  RobeClient,
} from '@kodit/core/data-api';
import { finalize } from 'rxjs/operators';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { AlertService, SharedService } from '@kodit/core/services';
import { FormHelper, MagacinFormService } from '@kodit/core/form-definitions';

@Component({
  selector: 'kodit-prebacivanje-usluga-roba-dialog',
  templateUrl: './prebacivanje-usluga-roba-dialog.component.html',
  styleUrls: ['./prebacivanje-usluga-roba-dialog.component.scss'],
})
export class PrebacivanjeUslugaRobaDialogComponent
  implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  form!: FormGroup;

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _fb: FormBuilder,
    private _dialogConfig: DynamicDialogConfig,
    private _sharedService: SharedService,
    private _alertService: AlertService,
    private _magacinFS: MagacinFormService,
    private _robaClient: RobeClient,
    private _formHelper: FormHelper,
  ) {}

  ngOnInit(): void {
    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.onSend();
      })
    );

    this.form = this._fb.group({
      uslugeIds: [this._dialogConfig.data],
      magacini: this._magacinFS.GetMagaciniFormArray(),
    });
  }

  onSend() {

    if(this.form.controls.magacini.value.length == 0)
    {
      this._formHelper.invalidateFormMagacin(this.form);
      return;
    }

    this._sharedService.displayLoadingScreen(
      true,
      'Prebacivanje usluga u robu'
    );
    this._subs.add(
      this._robaClient
        .prebacivanjeUslugaURobu(
          this.form.value as PrebacivanjeUslugeURobuCommand
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if (res.succeeded) {
            this._alertService.addSuccessMsg(res.data);
            this._dialogRef.close();
          } else {
            this._alertService.addWarnMsg(res.messages[0]);
            this._dialogRef.close();
          }
        })
    );
  }

  selectedMagacini(magacini: IMagacinDto[]) {
    (this.form.controls.magacini as FormArray).clear();
    magacini.forEach((element) => {
      (this.form.controls.magacini as FormArray).push(
        this._magacinFS.GetMagacinFormGroup(element)
      );
    });
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
